// extracted by mini-css-extract-plugin
module.exports = {"container":"Articles_container___BISe"};